import React from 'react';
import { CheckCircle, Info, X } from 'react-feather';
import Button from '../Button/Button';
import { BG_COLORS, TEXT_COLORS } from '../globalTheme';
import { COLOR_TYPE } from '../globalTypes';
import { Typography } from '../Typography/Typography';

export type BannerProps = {
	message: string;
	secondaryMessage?: string;
	variant: COLOR_TYPE;
	actionButtonType?: COLOR_TYPE;
	onAction?: () => void;
	actionText?: string;
	customActionButton?: React.ReactNode;
};

const variantIcons = {
	success: CheckCircle,
	warning: Info,
	error: X,
	gray: Info,
	primary: Info,
	blueGray: Info,
	white: Info
};

const Banner: React.FC<BannerProps> = ({
	message,
	secondaryMessage,
	variant,
	onAction,
	actionText = '',
	actionButtonType = 'primary',
	customActionButton
}) => {
	const Icon = variantIcons[variant];

	return (
		<div
			style={{
				backgroundColor: BG_COLORS[variant],
				color: TEXT_COLORS[variant]
			}}
		>
			<div className="flex items-center justify-between p-2 rounded-lg">
				<div className="flex items-center">
					<Icon className="h-5 w-5 mr-3" data-testid="banner-icon" />
					<Typography weight="regular" size="md">
						{message}
					</Typography>
				</div>
				{customActionButton ? (
					customActionButton
				) : (
					<>
						{onAction && (
							<Button label={actionText} onClick={onAction} color={actionButtonType}></Button>
						)}
					</>
				)}
			</div>
			<div className="flex items-center justify-between p-2 rounded-lg">
				<div className="flex items-center">
					<div className="flex text-wrap">
						<Typography weight="regular" size="sm" color="subtitle">
							{secondaryMessage}
						</Typography>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Banner;
